export type ToolHolderOption = {
  value: string;
  labelKey: string;
};

export const toolHolderTypes: ToolHolderOption[] = [
  { labelKey: 'traceability.holderTab.options.hotShrink', value: 'frettage_chaud' },
  { labelKey: 'traceability.holderTab.options.coldShrink', value: 'frettage_froid' },
  { labelKey: 'traceability.holderTab.options.collet', value: 'pince_serrge' },
  { labelKey: 'traceability.holderTab.options.hydraulic', value: 'pince_hydraulique' },
  { labelKey: 'traceability.holderTab.options.other', value: 'autre' },
];
